import { Component } from '@angular/core';
@Component({
    selector: "app-race-to-gold",
    templateUrl: "./race-to-gold.component.html",
    styleUrls: ["./race-to-gold.component.scss"],
  })
  export class RaceToGoldComponent {
    title = 'viewer-app';   
            
    constructor() { }
    ngOnInit(): void {
  
  }
  
}